export default __webpack_public_path__ + "static/media/rug12-min.4e575858.jpg";